import { render, staticRenderFns } from "./UiSearch.vue?vue&type=template&id=326d5a24&"
import script from "./UiSearch.vue?vue&type=script&lang=js&"
export * from "./UiSearch.vue?vue&type=script&lang=js&"
import style0 from "./UiSearch.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports